<div class="dialog-wrapper">
    <mat-icon style="
        color: hsl(42, 96%, 58%);
        font-size: 100px;
        width: 100px;
        height: 100px;
      ">
        {{ data.icon }}</mat-icon>
    <h1 mat-dialog-title>{{ data.title }}!</h1>
    <p style="text-align: center;
    max-width: 350px;">
        {{ data.paragraph }}
    </p>
    <p style="font-weight: bolder">
        {{ data.question }}
    </p>
    <mat-dialog-actions class="dialog-buttons" align="center">
        <lex-button [mat-dialog-close]="true" cdkFocusInitial containerStyle="width: 212px; max-width: 212px" [label]="lextranslate.i18n['1fc7096e-68a4-4c98-9dc8-bae774cf9319']">
        </lex-button>
    </mat-dialog-actions>
</div>